import {
  CalendarOutlined,
  DesktopOutlined,
  FileOutlined,
  MobileOutlined,
  TabletOutlined,
} from "@ant-design/icons";
import { Collapse, Spin, Typography } from "antd";
import dayjs from "dayjs";
import { Virtuoso } from "react-virtuoso";
import { IProjectDocumentDownloadHistory } from "../../models/Research";
import { useGetHistoryDownloadDocument } from "../../query/ReseachQuery";
import { parseBrowser, parseDevice, parseOS } from "../../utils/detect.util";
import MyAvatar from "../common/Avatar";
import IpAddressIcon from "../icons/IpAddressIcon";

interface ProjectDocumentHistoryDownloadProps {
  documentId: number;
}

const ProjectDocumentHistoryDownload = ({
  documentId,
}: ProjectDocumentHistoryDownloadProps) => {
  const { data, isLoading } = useGetHistoryDownloadDocument(documentId);

  const detectDevice = (userAgent: string) => {
    const device = parseDevice(userAgent);
    if (device === "Mobile") return <MobileOutlined />;
    if (device === "Tablet") return <TabletOutlined />;
    if (device === "Desktop") return <DesktopOutlined />;
    return "🌐";
  };

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <Spin />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        Chưa có lịch sử tải xuống
      </div>
    );
  }

  return (
    <div>
      <Typography.Text className="font-semibold block mb-3">
        Lịch sử tải xuống
      </Typography.Text>
      <Virtuoso
        style={{ height: "400px" }}
        data={data}
        itemContent={(index, item: IProjectDocumentDownloadHistory) => {
          const browser = parseBrowser(item.userAgent);
          const os = parseOS(item.userAgent);
          return (
            <div className="mb-3">
              <div className="rounded-lg border transition-all">
                <div className="p-4">
                  <div className="flex items-start justify-between">
                    <div className="flex items-start gap-3 flex-1">
                      <MyAvatar name={item.userName} />

                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1">
                          <Typography.Text className="font-semibold">
                            {item.userName}
                          </Typography.Text>
                        </div>

                        <div className="flex items-center gap-4 text-sm flex-wrap">
                          <Typography.Text className="flex items-center gap-1">
                            <CalendarOutlined />
                            {dayjs(item.createAt).format("DD/MM/YYYY HH:mm:ss")}
                          </Typography.Text>

                          <Typography.Text className="flex items-center gap-1">
                            <IpAddressIcon />
                            {item.ipAddress}
                          </Typography.Text>

                          <Typography.Text className="flex items-center gap-1">
                            {detectDevice(item.userAgent)}
                            {browser} • {os}
                          </Typography.Text>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 flex items-center gap-2 border p-2 bg-gray-50 dark:bg-gray-800 rounded">
                    <FileOutlined />
                    <Typography.Text>{item.fileName}</Typography.Text>
                  </div>

                  <div className="mt-3">
                    <Collapse
                      ghost
                      size="small"
                      items={[
                        {
                          key: "1",
                          label: (
                            <Typography.Text className="text-sm">
                              Chi tiết User Agent
                            </Typography.Text>
                          ),
                          children: (
                            <div className="p-3 bg-gray-800/50 rounded text-xs font-mono break-all">
                              {item.userAgent}
                            </div>
                          ),
                        },
                      ]}
                      className="bg-transparent"
                      style={{
                        background: "transparent",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default ProjectDocumentHistoryDownload;
